<app-card [title]="'Insurance Information'">
  <form [formGroup]="insuranceForm" class="insurance-form">
    <!-- Section for Insurance Information -->
    <div class="section">
      <p>{{ insuranceCoverageText }}</p>
      <mat-radio-group class="radio-group" formControlName="isInsuranceSelected">
        <mat-radio-button [value]="true" class="radio-button">
          <span class="radio-label">Yes</span>
        </mat-radio-button>
        <mat-radio-button [value]="false" class="radio-button">
          <span class="radio-label">No</span>
        </mat-radio-button>
      </mat-radio-group>

      <!-- Content visible only when "Yes" is selected -->
      <div *ngIf="isInsuranceSelectedControl.value">
        <p>{{ applicableText }}</p>

        <div *ngFor="let option of insuranceTypes">
          <mat-checkbox class="custom-checkbox" (change)="onInsuranceTypeChange(option.insuranceTypeID, $event.checked)"
            [checked]="isInsuranceTypeSelected(option.insuranceTypeID)">
            <span class="checkbox-label">{{ option.description }}</span>
          </mat-checkbox>
        </div>


        <!-- Show additional fields if "Other" is selected -->
        <div [formGroup]="enrollmentOtherInsuranceDTOs" *ngIf="isInsuranceTypeSelected(otherInsuranceTypeID)">
          <div class="form-row">
            <div class="form-field">
              <label for="planName">Plan Name</label>
              <mat-form-field appearance="outline" class="full-width">
                <input matInput id="planName" formControlName="insuranceCompanyName" placeholder="Plan Name">
              </mat-form-field>
            </div>
            <div class="form-field">
              <label for="memberId">Member ID</label>
              <mat-form-field appearance="outline" class="full-width">
                <input matInput id="memberId" formControlName="memberID" placeholder="Member ID">
              </mat-form-field>
            </div>
          </div>
        </div>
        
        <p class="error" *ngIf="enrollmentInsuranceDTOs?.invalid && enrollmentInsuranceDTOs?.touched">
          Please select valid insurance type(s)
        </p>

        <!-- File Upload Section -->
        <div class="upload-container">
          <label for="fileUpload" class="upload-label">Upload Proof Of Insurance*</label>
          <div class="upload-box" [class.disabled]="selectedFiles.length > 0">
            <input id="fileUpload" type="file" (change)="onFilesSelected($event)" class="file-input"
              accept=".pdf,.png" [disabled]="selectedFiles.length > 0" (blur)="isInsuranceDocumentTouched = true"/>

            <div *ngIf="selectedFiles.length === 0" class="upload-placeholder">
              <div class="upload-icon-container">
                <img src="assets/images/uploadicon.svg" alt="Upload Icon" />
                <p>Drag or click to upload documents here</p>
                <small>(Supported file types: PDF, PNG)</small>
              </div>
            </div>

            <div class="uploaded-files" *ngIf="selectedFiles.length > 0">
              <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
                <div class="file-preview">
                  <img *ngIf="file.type === 'image'" [src]="file.preview" alt="{{ file.name }}" />
                  <mat-icon *ngIf="file.type !== 'image'" svgIcon="document-pdf"></mat-icon>
                </div>
                <p class="file-name">{{ file.name }}</p>
                <button mat-icon-button (click)="removeFile(i)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>

          </div>
        </div>
        <p class="error" *ngIf="insuranceDocument?.invalid && isInsuranceDocumentTouched && !insuranceDocument?.errors?.['fileUpload'] && !insuranceDocument?.errors?.['maxFileUploadSize']">
          Please upload proof of insurance
        </p>
        <p class="error" *ngIf="insuranceDocument?.errors?.['fileUpload']">
          {{insuranceDocument?.errors?.['fileUpload']}}
        </p>
        <p class="error" *ngIf="!insuranceDocument?.errors?.['fileUpload'] && insuranceDocument?.errors?.['maxFileUploadSize']">
          {{insuranceDocument?.errors?.['maxFileUploadSize']}}
        </p>


        <!-- Merck Patient Assistance Program Section -->
        <div class="section">
          <h2>Merck Patient Assistance Program Attestation</h2>
          <p [innerHTML]="merckProgramText"></p>
          <p>{{ attestationText }}</p>
          <p>{{ hardshipReasonText }}</p>
          <div *ngFor="let option of financialMedicalHardship">
            <mat-checkbox class="custom-checkbox"
              (change)="onMedicalHardshipChange(option.finMediHardshipTypeID, $event.checked)"
              [checked]="isFinHardshipTypeSelected(option.finMediHardshipTypeID)">
              <span class="checkbox-label"> {{ option.finMediHardshipType }}/</span>
            </mat-checkbox>
          </div>

          <p class="error" *ngIf="finMediHardshipDTOs?.invalid && finMediHardshipDTOs?.touched">
            Please select medical hardship reason(s)
          </p>

          <p [innerHTML]="expirationNoticeText"></p>
          <p>{{ applicableCoverageText }}</p>
          <mat-checkbox class="custom-checkbox" formControlName="isMedicarePartBCoverage">
            <span class="checkbox-label">I have Medicare Part B coverage</span>
          </mat-checkbox>
          <mat-checkbox class="custom-checkbox" formControlName="isMedicarePartDCoverage">
            <span class="checkbox-label">I have Medicare Part D coverage</span>
          </mat-checkbox>


          <p [innerHTML]="medicaidDisclaimerText"></p>
        </div>
        <div class="signature-field">
          <mat-label class="signature-label">Sign Here*</mat-label>
          <canvas #canvas class="signature-pad" width="500" height="100"
            [class.disabled]="isSignatureAccepted"></canvas>
        </div>

        <p class="error" *ngIf="insuranceSignature?.invalid && insuranceSignature?.touched">
          Signature is required
        </p>

        <div class="signature-button-container">
          <!-- Clear Signature Button -->
          <button class="button-Secondary" type="button" (click)="clearSignature()">
            Clear Signature
          </button>
          <!-- Accept Signature Button -->
          <button class="button-Primary" type="button" (click)="acceptSignature()" [disabled]="isSignatureAccepted">
            Accept Signature
          </button>
        </div>
        <!-- Hidden input to store the signature as base64 -->
        <input type="hidden">
      </div>

     
    </div>
    <!-- Signature Section -->



    <!-- Form Action Buttons -->
    <div class="button-container">
      <button type="submit" class="button-Secondary" (click)="onSave(true)" [disabled]="isFormInvalid">Save and Exit</button>
      <button class="button-Primary" (click)="onSave()" [disabled]="isFormInvalid">Next: {{nextStep?.enrollmentStepName}}</button>
    </div>
  </form>
</app-card>

<loading-spinner *ngIf="isLoading"></loading-spinner>